"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSmsModule = exports.isSensorModule = exports.isECPDummy = exports.isECPSensor = exports.isSmartPlasticsType = exports.isSmartPlasticsPartModel = exports.SmartPlasticsPartModelSchema = void 0;
const tslib_1 = require("tslib");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const zod_1 = require("zod");
const ArticleType_1 = require("../ArticleType");
const SmartPlasticsPartSchema_1 = tslib_1.__importDefault(require("../../generated/zod/modelSchema/SmartPlasticsPartSchema"));
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
exports.SmartPlasticsPartModelSchema = SmartPlasticsPartSchema_1.default.extend({
    articleType: zod_1.z.custom((a) => a === ArticleType_1.ArticleType.zubehoer, { message: 'invalid ArticleType' }),
    // JSON fields => LocalizedText's
    artNr: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    description: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    akeneoUuid: zod_1.z
        .string()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
});
const isSmartPlasticsPartModel = (whatever) => {
    var _a;
    return (_a = exports.SmartPlasticsPartModelSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isSmartPlasticsPartModel = isSmartPlasticsPartModel;
const isSmartPlasticsType = (u) => {
    return (0, echain_shared_ts_utils_1.isValueInEnum)(echain_prisma_client_1.SmartPlasticsType, u);
};
exports.isSmartPlasticsType = isSmartPlasticsType;
const isECPSensor = (smartPlasticsPartModel) => {
    return smartPlasticsPartModel.articleSpecs.includes(echain_prisma_client_1.ArticleSpec.SmartPlasticsECPSensor);
};
exports.isECPSensor = isECPSensor;
const isECPDummy = (smartPlasticsPartModel) => {
    return smartPlasticsPartModel.articleSpecs.includes(echain_prisma_client_1.ArticleSpec.SmartPlasticsECPDummy);
};
exports.isECPDummy = isECPDummy;
const isSensorModule = (smartPlasticsPartModel) => {
    return smartPlasticsPartModel.articleSpecs.includes(echain_prisma_client_1.ArticleSpec.SmartPlasticsModule);
};
exports.isSensorModule = isSensorModule;
const isSmsModule = (smartPlasticsPartModel) => {
    return smartPlasticsPartModel.articleSpecs.includes(echain_prisma_client_1.ArticleSpec.SmartPlasticsSMSModule);
};
exports.isSmsModule = isSmsModule;
//# sourceMappingURL=SmartPlasticsPartModel.js.map